'use strict';

const { h } = require('phy');

function AlertBar({
  advert: {
    id,
    destination,
    headerBar: {
      message,
      buttonText,
      backgroundColour,
      textColour,
      buttonColour,
      buttonTextColour,
    },
  },
  closeHandler,
}) {
  const sectionStyle = `background-color: #${backgroundColour}; color: #${textColour};`;
  const buttonStyle = `background-color: #${buttonColour}; color: #${buttonTextColour}`;

  return h(
    'section.alertbar',
    {
      'data-bhw': 'alertbar',
      style: sectionStyle,
    },
    h('.page-container.alertbar-content', [
      h(
        'a.alertbar-close',
        {
          'data-bhc': 'alertbar:close',
          onClick: closeHandler,
          style: { color: `#${textColour}` },
        },
        h('span.icon-x')
      ),
      h('span.alertbar-text', message),
      h(
        'a.button.alertbar-button',
        {
          'data-bhc': `alertbar:${id}`,
          href: destination,
          target: '_blank',
          rel: 'noopener',
          style: buttonStyle,
        },
        h('span.alertbar-button-text', buttonText)
      ),
    ])
  );
}

module.exports = AlertBar;
